import React from "react";
import { bool } from "prop-types";
import Header from "@insightfulscience/atomic-react/Header";
import Navbar from "@insightfulscience/atomic-react/Navbar";
import NavbarItem from "@insightfulscience/atomic-react/Navbar/Item";
import NavbarItemLink from "@insightfulscience/atomic-react/Navbar/Link";
import NavbarSearch from "@insightfulscience/atomic-react/NavbarSearch";
import Button from "@insightfulscience/atomic-react/Button";
import Icon from "@insightfulscience/atomic-react/Icon";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Form from "@insightfulscience/atomic-react/Form";
import Input from "@insightfulscience/atomic-react/Input";
import prerenderedLogo from "../PrerenderedLogo";
import routes from "../routes";

const SiteHeader = ({ isAuthorized = false }) => {
	const [t] = useLocale("header");
	return (
		<Header logo={prerenderedLogo}>
			<Navbar inverted nav="primary">
				<NavbarItem>
					<NavbarItemLink href={routes.external.graphPadPrism}>{t("PRISM")}</NavbarItemLink>
				</NavbarItem>
				<NavbarItem>
					<NavbarItemLink href={routes.external.customers}>{t("CUSTOMERS")}</NavbarItemLink>
				</NavbarItem>
				<NavbarItem>
					<NavbarItemLink href={routes.external.resources}>{t("RESOURCES")}</NavbarItemLink>
				</NavbarItem>
				<NavbarItem>
					<NavbarItemLink href={routes.external.support}>{t("SUPPORT")}</NavbarItemLink>
				</NavbarItem>
				<NavbarItem>
					<NavbarItemLink href={routes.external.howToBuy}>{t("HOW_TO_BUY")}</NavbarItemLink>
				</NavbarItem>
			</Navbar>
			<Navbar nav="secondary" inverted>
				<NavbarItem secondary>
					<NavbarItemLink href={routes.external.cart}>
						<Icon name="shopping-cart" />
						{t("CART")}
					</NavbarItemLink>
				</NavbarItem>
				<NavbarItem secondary>
					<NavbarItemLink href={routes.myAccount} className="nav__item-link">
						<Icon name="user-alt" /> {isAuthorized ? t("MY_ACCOUNT") : t("SIGNIN")}
					</NavbarItemLink>
				</NavbarItem>
				<NavbarSearch>
					<Form method="get" action="/search/">
						<Input
							type="search"
							id="searchquery"
							name="searchquery"
							placeholder="Search..."
							autoComplete="off"
						/>
					</Form>
				</NavbarSearch>
				<NavbarItem secondary className="secondary-nav__item-trial">
					<Button.Link size="s" href={routes.external.freeTrial}>
						<Icon name="arrow-to-bottom" /> {t("FREE_TRIAL")}
					</Button.Link>
				</NavbarItem>
			</Navbar>
		</Header>
	);
};

SiteHeader.propTypes = {
	isAuthorized: bool,
};

export default SiteHeader;
